<template>
	 <PuSkeleton v-if="!item.image" style="width:100%;height:450px" />

	<div class="Card storeCard" v-else  @click="storePopUpHandlerMobile(item.stores)"  >
			<!-- <router-link v-if="item.stores.length===1" :to="{ path: '/store.html', query: { store: item.stores[0].id } }"> -->
			<div class="hoverelay"  >
				<div class="circleImg">
 					<img class="brand" :src="item.image" :alt="item.image" />
				</div>
				<div class="distance">
					<div class="brandNameBox">
						<div class="homeBrandName">
							<p>{{ item.name }}</p>
						</div>
						<div class="locationIcons"> 
							<img class="mapIconMobile" src="/img/maps.png" />
							<p>{{ sortDistanceStores }} Km</p>
						</div>
					</div>
					<!-- to="/store.html" -->
				
					<div class="moreLinks forMobile">

							<router-link v-if="item.stores.length===1"
								:to="{ path: '/store.html', query: { store: item.stores[0].id } }"
								class=" text-dark" >
								View Store
							</router-link>
							<p v-else @click="storePopUpHandlerMobile(item.stores)">
								View Store
							</p>
						
					</div>
					
				</div>
			</div>
		<!-- </router-link> -->
		<div class="brandImage">
				<!-- <router-link :to="{ path: '/store.html', query: { store: item.stores[0].id } }"> -->
				<a>
					<img class="image"  :src="item.featured_image" />
				</a>
			<div class="sotreOverlay"> 
				<div class="storeLocationWrap" v-for="(store,i) in item.stores" :key="i">
					<router-link
							:to="{ path: '/store.html', query: { store: store.id } }"
						
						>
					<p class="store-title-icon"> 
						<!-- <img class="image store-icon"  src="/img/store.png"  /> -->
						<span> {{store.name.replace(/"/g, '').substring(store.name.indexOf(",") + 1)}}</span> </p>
				
					<img
                        v-if="store.temp_store_close==1"
                        style="width:50px;height:32px;filter:invert(1)"
                        src="/img/store-closed-icon.png"
                        alt="Store Closed"
                      />
					  <!-- <div></div> -->
					
					<div class="storeLocation">
					
					 <small v-if="store.ratings.avg_rating > 0" class="cardRatingBox"><i class="fa fa-star" ></i> {{store.ratings.avg_rating}}</small>
					
						
						<span>
							<img src="/img/locationMarker.png" alt=""> {{ store.distance }} Km
						</span>
					</div>
					</router-link>
				</div>
			</div>
				
				
			</div>



		</div>
</template>
<style>

.storeLocationWrap .store-title-icon{
	display: inline-block;
    width: 100%;
    margin: 0;
}
	.storeLocationWrap .store-title-icon span{
		    float: left;
    width: calc(100% - 35px);
	}



	.storeLocationWrap img.store-icon{
		width: 20px !important;
    margin: 0px;
    display: unset;
	margin-right: 5px;
	position: relative;
	float: left;
	}
/* .brandImage:hover  .storeLocationWrap img.store-icon::before{
	content:  '';
	position: absolute;
	top: 0;
	left: 0;
	    background: #fff;
    border-radius: 5em;
    padding: 1.2em;
} */
	
	.storeLocationWrap{
		padding: 10px; 
		min-height: 65px;
		/* border-bottom: 1px solid #585858; */
	}
	.storeLocationWrap:hover{
		background-color: rgb(0 0 0 / 90%);
	}
	.storeLocation {
		display: inline-block;
    	width: 100%;
	}
	.storeLocation span{
		float: right;
		font-size: var(--font-size-regular);
		color: #fff;
		margin-top: 2px;
	}
	.storeLocation span img{
		width: 11px;
		display: inline-block;
		margin-top: -3px;
		margin-right: 3px;
	}
	.storeLocation i{
		color: #e6c40d !important; 
		font-size: var(--font-size-regular);
		margin-right: 2px;
	}
	.cardRatingBox{
		/* background-color: #e6c40d; */
		/* padding: 1px 6px; */
		color: #fffafa;
		font-size: var(--font-size-regular);
	}
	.storeLocationWrap p{
		color: #fff;
		font-size: var(--font-size-regular);
		margin-bottom: 5px; 
		/* font-weight: bold; */
	}




	.brandImage{
		position: relative;
		display: inline-block;
		width: 100%;
		/* border: 1px solid #d6d6d6; */
		border-top: none;
		border-bottom-right-radius: 0;
		overflow: hidden;
		border-bottom-left-radius: 0;
	}
	.brandImage img{
		width: 100%;
	}
	.sotreOverlay{
		position: absolute;
		bottom: 0px;
		left: 0;
		height: 100%;
		width: 100%;
		background-color: rgb(0 0 0 / 80%);
		border: 1px solid #d6d6d6;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		overflow: hidden;
		border-top: none;
		padding:0px;
		overflow-y: auto;
		opacity: 0;
		transition: opacity .2s ease-in-out;
	} 
	.storeCard:hover .sotreOverlay{
		opacity: 1;	 
	}
	.sotreOverlay .storeLocationWrap:last-child{
		border: none;
	}


	.sotreOverlay::-webkit-scrollbar {
		background-color:#00000094;
		width:10px
	}
	
	.sotreOverlay::-webkit-scrollbar-track {
		background-color:#00000094
	}
	.sotreOverlay::-webkit-scrollbar-track:hover {
		background-color:#00000094
	}

	/* scrollbar itself */
	.sotreOverlay::-webkit-scrollbar-thumb {
		background-color: #333;
		border-radius:10px;
		border:3px solid #000
	}
	.sotreOverlay::-webkit-scrollbar-thumb:hover {
		background-color:#333;
		border:3px solid #000
	}

	/* set button(top and bottom of the scrollbar) */
	

	/* .moreStores:before {
	    content: " ";
	   width: 0; 
	  height: 0; 
	  border-left: 10px solid transparent;
	  border-right: 10px solid transparent;
	  
	  border-bottom: 10px solid red;
	    position: absolute;
	    top: 0px;
	    left: 31px;
	}
	.moreStores {
	    position: absolute;
	    z-index: 1;
	    top: 20px;
	    background: #fff;
	    color: black;
	    width: 450px;
	    padding:  25px;
	    display: none;
	}
	.moreStores.storeDrop {
	    display: block;
	   
	} */
	/* .slick-slide.slick-active:nth-child(4) .moreStores:before {
	   left: 90%;
	}
	.slick-slide.slick-active:nth-child(4) .moreStores{
	  
	    top: 20px;
	    
	    right: 0px;
	   
	} */
	/* .moreStores.storeDrop::before {
	    content: '';
	    width: 100vw;
	    height: 100vh;
	    background: rgba(0,0,0,0.6);
	    position: fixed;
	    left: 0;
	    right: 0;
	    top: 0;
	    transform: none

	} */

	.Card {
		display: flex;
		flex-direction: column !important;
		padding: 0 15px;
		box-sizing: border-box;
		width: 25%;
        margin-bottom: 1rem;
        cursor: pointer;
	}

	.Card .distance {
		display: block;
		float: left;
    	padding-left: 15px;
		width: calc(100% - 70px);
    	text-align: left;
		/* transition: all 500ms ease-in-out; */
	}
	.mapIconMobile{
		width: 11px;
	}
	.hoverelay {
		width: 100%;
		float: left;
		padding-top: 14px;
		box-sizing: border-box;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px; 
		/* min-height: 145px; */
		/* border-top: 1px solid transparent;
		border-right: 1px solid transparent;
		border-left: 1px solid transparent; */
		min-height: 100px;
	}
	.moreLinks {
		color: #626262;
		font-size: 16px;
		font-family: 'lhmRegular';
		text-decoration: none;
		margin-top: 5px;
		position: relative;
	}
	a.moreLinks.router-link-active {
		border-bottom: none;
		color: #626262 !important;
		background: none;
	}
	.distance > p {
		margin-left: 5px;
	}
	/* .mapIconMobile{

	} */
	.locationIcons {
		display: flex;
		align-items: center;
		/* border-bottom: 1px solid #eeeeee; */
		width: 100%;
		justify-content: flex-start;
	}
	.locationIcons > p {
		margin-left: 5px;
		margin-bottom: 0px;
		font-family: 'lhmRegular';
	}

	.hoverelay:focus {
		outline: none;
	}
	.Card .hoverelay {
		background: #fff; 
		padding-left: 15px;
    	padding-right: 15px;
    	padding-bottom: 15px;
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		align-items: center;
		display: flex;
    	justify-content: flex-start;
	}
	.Card .brand {
		margin-top: 0px; 
	}
	.Card:focus {
		outline: none;
	}
	.distance {
		display: none;
		text-align: center; 
		font-size: 14px;
		align-items: baseline;
		line-height: 24px;
		color: #626262;
	}
	.distance > div > img {
		width: 12px;
	}
	.brand {
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		height: auto;
		margin-top: 60px;
	}
	.image {
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 100%;
		border-radius: 0;
		border-top-right-radius: 0px;
		border-top-left-radius: 0px;
 
	}
	.homeBrandName p{
		width: 100%;
		font-size: 14px; 
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-family: 'lhmMedium';
		text-transform: uppercase;
	}
	/* Responsive  */
	@media screen and (min-device-width: 1700) and (max-device-width: 2500px) {
		.hoverelay {
			min-height: 247px;
		}
	}
	@media screen and (max-width: 767px) {
		.sotreOverlay{
			display: none;
		}
		.moreLinks {
			/* display: none; */
			font-size: var(--font-size-regular);
			padding-bottom: 10px;
		}

		.distance {
			display: flex;
			justify-content: center;
			/* transition: all 500ms ease-in-out; */
		}
		.locationIcons {
			border-bottom: none;
			margin-bottom: 0px;
			width: 100%;
		}
		.locationIcons > p {
			font-size: 14px;
			line-height: 24px;
			font-family: "lhm";
			color: #626262;
		}
		.distance > a {
			display: none;
		}
		.Card {
			padding: 0 5px !important;
			min-width: 136px;
			width: 100%;
		}
		.brand {
			display: block;
			margin-left: auto;
			margin-right: auto;
			width: 40%;
			height: auto;
			margin-top: 0px;
		}
		.hoverelay {
			min-height: 70px;
			display: flex;
			flex-direction: column;
			justify-content: space-evenly;
			background: #fff;

			/* border-top: 0.25px solid #A2A2A2;
			border-right: 0.25px solid #A2A2A2;
			border-left: 0.25px solid #A2A2A2; */
			/* transition: all 500ms ease-in-out; */
			/* min-height: 60px; */
		}
	}
</style>
<script>
	export default {
		props: ["item"],
		data() {
			return {
				store: null,
				link: ''
			};
		},
		methods: { 
			openStorePopup(){
				 this.$root.isStorePopUpMobile = false
			},
			storePopUpHandlerMobile(stores) {
				if(this.$root.window.width < 767){
					this.$root.popUpStoresMobile = stores;
					if(stores.length>1){
						this.$root.isStorePopUpMobile = true;
					}else{
						this.$router.push({ path: '/store.html', query: { store: stores[0].id }});
						// this.$router.push({ path: '/store.html', query: { store: item.stores[0].id }});
					}
				}
			},
		},
		computed: {
			sortDistanceStores() {
				return Math.min.apply(
					null,
					this.item.stores.map((d) => d.distance), 
				);
			},
		},
	};
</script>